import { render } from "./ProductionIndex.vue?vue&type=template&id=6b98210c"
import script from "./ProductionIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Production/ProductionIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b98210c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b98210c', __exports__)) {
    api.reload('6b98210c', __exports__)
  }
  
  module.hot.accept("./ProductionIndex.vue?vue&type=template&id=6b98210c", () => {
    api.rerender('6b98210c', render)
  })

}


export default __exports__